/* eslint-disable no-console */
import {
  DownloadOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
  UploadOutlined
} from '@ant-design/icons';
import {Button, Flex, Popconfirm, Tooltip, Upload} from 'antd';
import React, {useState} from 'react';

import {ReactComponent as JobIcon} from '../../../assets/icons/jobsIcon.svg';
import UpgradeButton from '../../../components/UpgradeButton/UpgradeButton';
import {allUploadType} from '../../../services/constants/uploadTypes';
import {uploadFile} from '../../../services/modules/UploadAndJobs/uploadFile';
// import {accessModule} from '../../../store/companyStore/companyDetailsStore';
import {
  isOnboardingDone,
  shouldBlockFree,
  shouldBlockFreeOrTrial
} from '../../../utils/SubscriptionHelper';
// import DownloadSampleModal from '../../DownloadTemplate/DownloadSampleModel';

const TableTitleHeader: React.FC<{
  title?: string;
  filter: {facilityId: string; selectedYear: string};
  addButton: {
    setShowModel: React.Dispatch<React.SetStateAction<boolean>> | undefined;
    setIsEdit: React.Dispatch<React.SetStateAction<boolean>> | undefined;
    buttonTitle: string;
  };
  sampleDownload: {downTitle?: string; href: string};
  jobs: {
    setShowJobs: React.Dispatch<React.SetStateAction<boolean>> | null;
    uploadType: allUploadType;
  };
  deleteButton: {
    selectedRowKeys: string[];
    handleDelete: (_id: string[] | string) => void;
  };
  shouldEdit?: boolean;
  refresh: {setRefresh: React.Dispatch<React.SetStateAction<boolean>>};
  isTable?: boolean;
  onlyYear?: boolean;
  showAddOnly?: boolean;
  onlyUpload?: boolean;
  shouldDisable?: boolean;
  tooltip?: string;
  blockAddition?: boolean;
  // accessModuleType?: accessModule | undefined | null | string;
  // accessModuleDataLimit?: number;
}> = ({
  title = '',
  filter,
  addButton,
  sampleDownload,
  jobs,
  deleteButton,
  refresh,
  isTable = true,
  showAddOnly = false,
  onlyYear = false,
  onlyUpload = false,
  shouldDisable = true,
  tooltip = '',
  shouldEdit = true,
  blockAddition = false
  // accessModuleType = null
  // accessModuleDataLimit = 0
}) => {
  const {facilityId = '', selectedYear = ''} = filter;
  const {setShowModel, setIsEdit, buttonTitle = 'Add'} = addButton;
  const {downTitle = 'Download Sample', href} = sampleDownload;
  const {setShowJobs, uploadType} = jobs;
  const {selectedRowKeys, handleDelete} = deleteButton;
  const {setRefresh} = refresh;
  const [isUploading, setIsUploading] = useState(false);
  // const [openDownload, setOpenDownload] = useState(false);

  return (
    <Flex gap={16} className="tableButtonFlex">
      {title ? (
        <Flex align="center" justify="center" gap="1rem">
          <div className="tableTitle">{title}</div>
          {tooltip && (
            <Tooltip title={tooltip} autoAdjustOverflow={true} arrow={true}>
              <ExclamationCircleOutlined className="icon" />
            </Tooltip>
          )}
        </Flex>
      ) : (
        <div></div>
      )}
      <Flex className="tableButton">
        <Tooltip
          title={
            isTable
              ? onlyYear
                ? !selectedYear
                  ? 'Please select year'
                  : 'Refresh Table'
                : !(facilityId && selectedYear)
                  ? 'Please select facility and year'
                  : 'Refresh Table'
              : 'Refresh Table'
          }
        >
          <Button
            type="default"
            icon={<ReloadOutlined />}
            onClick={() => {
              setRefresh(true);
            }}
            disabled={
              isTable
                ? onlyYear
                  ? !selectedYear
                  : !(facilityId && selectedYear)
                : false
            }
          />
        </Tooltip>
        {!showAddOnly && shouldEdit && (
          <>
            {blockAddition || shouldBlockFreeOrTrial() ? (
              <></>
            ) : (
              <Tooltip
                title={
                  isTable
                    ? onlyYear
                      ? !selectedYear
                        ? 'Please select year'
                        : ''
                      : !(facilityId && selectedYear)
                        ? 'Please select facility and year'
                        : ''
                    : ''
                }
              >
                <Button
                  onClick={() => {
                    if (setShowJobs !== null) {
                      setShowJobs(true);
                    }
                  }}
                  className="jobs"
                  disabled={
                    isTable
                      ? onlyYear
                        ? !selectedYear
                        : !(facilityId && selectedYear)
                      : false
                  }
                  icon={<JobIcon />}
                />
              </Tooltip>
            )}

            {shouldBlockFreeOrTrial() || blockAddition ? (
              <></>
            ) : (
              <>
                {/* {accessModuleType === accessModule.externalStakeholders ||
                accessModuleType === accessModule.facility ? (
                  <>
                    <DownloadSampleModal
                      open={openDownload}
                      href={href}
                      onDownload={() => {
                        setOpenDownload(false);
                      }}
                      onCancel={() => {
                        setOpenDownload(false);
                      }}
                      maxRecords={accessModuleDataLimit}
                      accessModuleType={accessModuleType}
                    />
                    <Button
                      icon={<DownloadOutlined />}
                      onClick={() => {
                        setOpenDownload(true);
                      }}
                    >
                      {downTitle}
                    </Button>
                  </>
                ) : ( */}
                <Button icon={<DownloadOutlined />} href={href} download>
                  {downTitle}
                </Button>
                {/* )} */}

                <Tooltip
                  title={
                    isTable
                      ? onlyYear
                        ? !selectedYear
                          ? 'Please select year'
                          : ''
                        : !(facilityId && selectedYear)
                          ? 'Please select facility and year'
                          : ''
                      : ''
                  }
                >
                  <Upload
                    accept=".csv, text/csv"
                    customRequest={(option) => {
                      setIsUploading(true);
                      const {file, onSuccess, onError} = option;
                      uploadFile(
                        file,
                        uploadType,
                        isTable ? facilityId : '',
                        isTable ? selectedYear : ''
                      )
                        .then(() => {
                          if (onSuccess) onSuccess('ok');
                          if (setShowJobs !== null) {
                            setShowJobs(true);
                          }
                        })
                        .catch((err) => {
                          if (onError) {
                            onError(err);
                          }
                        })
                        .finally(() => {
                          setIsUploading(false);
                        });
                    }}
                    showUploadList={false}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      disabled={
                        isTable
                          ? onlyYear
                            ? !selectedYear
                            : !(facilityId && selectedYear)
                          : false
                      }
                      loading={isUploading}
                    >
                      {isUploading ? 'Uploading....' : 'Click to Upload'}
                    </Button>
                  </Upload>
                </Tooltip>
              </>
            )}
          </>
        )}
        {selectedRowKeys.length > 0 && !shouldBlockFree() && (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              handleDelete(selectedRowKeys);
            }}
          >
            <Button type="primary">
              {selectedRowKeys.length >= 2 ? 'Delete Selected' : 'Delete'}
            </Button>
          </Popconfirm>
        )}

        {!onlyUpload && shouldEdit && (
          <Tooltip
            title={
              isTable
                ? onlyYear
                  ? !selectedYear
                    ? 'Please select year'
                    : ''
                  : !(facilityId && selectedYear)
                    ? 'Please select facility and year'
                    : ''
                : ''
            }
          >
            {blockAddition || shouldBlockFree() ? (
              <UpgradeButton title={buttonTitle} />
            ) : (
              <Button
                onClick={() => {
                  if (isOnboardingDone() && setIsEdit && setShowModel) {
                    setShowModel(true);
                    setIsEdit(false);
                  }
                }}
                type="primary"
                disabled={
                  isTable
                    ? onlyYear
                      ? !selectedYear && shouldDisable
                      : !(facilityId && selectedYear && shouldDisable)
                    : false && shouldDisable
                }
              >
                {buttonTitle}
              </Button>
            )}
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
};

export default TableTitleHeader;
